import { DepartmentActionTypes } from './type';

/****** action creator ******/

/****** 获取部门列表 ******/
export const fetch_department_list = (onSuccess ?:any) => ({ type: DepartmentActionTypes.FETCH_DEPARTMENT_LIST, onSuccess});